<template>
  <div class="pay-page" >
    <mt-header fixed title="立即支付" style="background:#ffffff;color:#262626;">
        <mt-button icon="back" slot="left" @click="goBack"></mt-button>
    </mt-header>

    <div class="scroll-wrapper">
        <div class="scroll-content">
            <div class="pay-info">
                <h2>{{g_description}}</h2>
                <span>{{gm_name}}</span>
                <p><span>¥</span>{{total}}</p>
            </div>

            <ul class="pay-way">
                <li @click="selectType('huabei')" :class="{'selected':payType == 'huabei' }">
                    <div class="pay-wrapper">
                        <div class="content">
                            <img src="../assets/images/pay_antpay@3x.png" alt="花呗支付">
                            <div class="info">
                                <span>花呗支付</span><br/>
                                <span>推荐有支付宝-花呗的用户使用</span>
                            </div>
                        </div>
                        <div class="icon"></div>
                    </div>
                    <ul class="huabei-list" id="huabei">
                        <li @click="selectHBItem(0)" :class="{'active':itemIndex==0}">
                            <span>不分期</span>
                        </li>
                        <li v-for="(item,index) in hb_rates" :key="item.key" :class="{'active':itemIndex==(index+1)}" @click="selectHBItem(index+1)">
                            <span>￥{{item.value}} x {{item.key}}期</span>
                            <span>利率：{{item.rate}}%</span>
                        </li>
                    </ul>
                </li>
                <!-- <li @click="selectType('wxpay-h5')" :class="{'selected':payType == 'wxpay-h5' }">
                    <div class="pay-wrapper">
                        <div class="content">
                            <img src="../assets/images/pay_wechatpay@3x.png" alt="">
                            <div class="info">
                                <span>微信支付</span><br/>
                                <span>推荐微信5.0及以上版本的用户使用</span>
                            </div>
                        </div>
                        <div class="icon"></div>
                    </div>
                </li> -->
                <li @click="selectType('alipay')" :class="{'selected':payType == 'alipay' }">
                    <div class="pay-wrapper">
                        <div class="content">
                            <img src="../assets/images/pay_alipay@3x.png" alt="">
                            <div class="info">
                                <span>支付宝支付</span><br/>
                                <span>推荐有支付宝账户的用户使用</span>
                            </div>
                        </div>
                        <div class="icon"></div>
                    </div>
                </li>
                <li @click="selectType('scanpay')" :class="{'selected':payType == 'scanpay' }">
                    <div class="pay-wrapper">
                        <div class="content">
                            <img src="../assets/images/pay_qrpay@3x.png" alt="">
                            <div class="info">
                                <span>扫码支付</span><br/>
                                <span>使用其他设备扫码，支持微信，支付宝</span>
                            </div>
                        </div>
                        <div class="icon"></div>
                    </div>
                </li>
            </ul>

            <div class="pay-btn" @click="gopay">
                立即支付
            </div>

            <div class="tips">
                <span>数据恢复越早越好，越早恢复概率越高</span><br/>
                <span>支付成功后开具增值税发票（支持电子或邮寄到付）</span>
            </div>

            

            <div class="payModal" v-if="payModalStatus" @touchmove.prevent>
                <div class="selectScanType" v-if="action == 'selectScanType'">
                    <div class="scanWrapper">
                        <img src="../assets/images/pay_qrpay_pic@3x.png">
                        <h2>请选择扫码类型</h2>
                        <ul class="btns">
                            <li @click="selectScanType('wxpay')">
                                <img class="scanImg" src="../assets/images/pay_qrpay_qr@3x.png">
                                <span class="create">生成</span>
                                <img class="wxpay" src="../assets/images/pay_qrpay_wechatpay@3x.png">
                                <span class="wechat">微信支付</span>
                                <span class="code">二维码</span>
                            </li>
                            <li @click="selectScanType('alipay')">
                                <img class="scanImg" src="../assets/images/pay_qrpay_qr@3x.png">
                                <span class="create">生成</span>
                                <img class="alipay" src="../assets/images/pay_qrpay_alipay@3x.png">
                                <span class="zfb">支付宝</span>
                                <span class="code">二维码</span>
                            </li>
                        </ul>
                    </div>
                    <img class="close" src="../assets/images/pay_qrpay_close@3x.png" @click="closeModal">
                </div>

                <div class="scanPay" v-if="action == 'scanPay'">
                    <h2>请使用<span :class="{'blue': topType == '支付宝','green': topType == '微信'}">{{topType}}</span>扫码支付</h2>

                    <div class="swipper">
                        <mt-swipe :auto="0" :continuous="false" @change="handleChange" :defaultIndex="defaultIndex">
                            <mt-swipe-item v-for="item in qr_codes" :key="item.type">
                                <div class="code-item">
                                    <img class="left" :style="{ 'opacity': item.type=='alipay' ? 1 : 0 }" src="../assets/images/pay_qrpay_left@3x.png">
                                    <div class="scan">
                                        <img class="wxIcon" v-if="item.type == 'wxpay'" src="../assets/images/pay_qrpay_wechatpay2@3x.png">
                                        <img class="zfbIcon" v-if="item.type == 'alipay'" src="../assets/images/pay_qrpay_alipay2@3x.png">
                                        <img class="qrcode" :src="item.code_url">
                                    </div>
                                    <img class="right" :style="{ 'opacity': item.type=='wxpay' ? 1 : 0 }"  src="../assets/images/pay_qrpay_right@3x.png">
                                </div>
                            </mt-swipe-item>
                        </mt-swipe>
                    </div>
                    
                    <p>{{direction}}可切换使用{{bottomType}}扫码支付</p>

                    <div class="complete" @click="goPayResult">
                        我已支付
                    </div>

                    <span @click="closeModal">放弃支付</span>
                </div>
            </div>

            <div class="disalog-wrapper" v-show="false" >
            <div v-show="false" class="dialog-tips dialog-center">
                    <div class="msg">订单已支付</div>
                    <div class="confirm-btn" @click.prevent="close">确定</div>
                </div>
            </div>
            <toastPay :show="showDialog" :msg="msg" @payComplete="payComplete" @gopay="gopay" @closeDialog="closeDialog"></toastPay>
            <open-insafari v-show="showNotice" ></open-insafari>
        </div>
    </div>
  </div>
</template>

<script>
import {Popup,Radio,Indicator,swipe} from 'mint-ui';
import toastPay from "./PayToast"
import OpenInsafari from "./modules/OpenInsafari"
import { mapState } from 'vuex'
import _ from 'lodash'
export default {
    name:"purchase",//购买服务
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            goods:{},
            modules:[],
            popupVisible:false,
            mid:"",//选中的id
            selectModule:{},
            payType:"",
            orderno:"",
            sorder_no:"",
            order:{},
            price:"",
            remark:"",
            showDialog:false,
            msg:"请确认支付是否已完成",
            clock:"",
            showTips:false,
            _isWeiXin: true,
            gm_name:'',
            goodsCategory:'',
            packageName:'',
            payModalStatus: false,
            hb_rates: [],
            hb_num: 0,
            itemIndex: 0,
            qr_codes: [
                {
                    type: 'alipay',
                    code_url: ''
                },
                {
                    type: 'wxpay',
                    code_url: ''
                }
            ],
            direction: '左滑',
            topType: '支付宝',
            bottomType: '微信',
            total : 0,
            g_description: '',
            gm_name: '',
            action: 'selectScanType',
            defaultIndex: 1,
            service_orders: []
        }
    },
    computed:mapState(['showNotice']),
    methods:{
        goPayResult(){
            if(!this.sorder_no){
                this.$router.push({name:'payresult',query:{orderno:this.orderno}})
            }else {
                this.$router.push({name:'payresult',query:{sorder_no:this.sorder_no}})
            }
        },
        selectScanType(type){
            this.defaultIndex = type == 'wxpay'?1:0
            this.action = 'scanPay'
        },
        handleChange(e){
            if(e == 0){
                this.topType = "支付宝"
                this.bottomType = "微信"
                this.direction = "左滑"
            }else {
                this.topType = "微信"
                this.bottomType = "支付宝"
                this.direction = "右滑"
            }
        },
        selectHBItem(index){
            this.itemIndex = index

            this.hb_num = index==0?0:this.hb_rates[index-1].key
        },
        getSystemConfig(){
            let info = {
                app_id: '30001081'
            }
            let vm = this
            this.$store.dispatch('getSystemConfig',info).then((res)=>{
                if(res.data.code===0){
                    let rates = res.data.res.hb_rates
                    for(let item in rates){
                        let num = (parseFloat(this.total))*(1+parseFloat(rates[item])/100)/parseFloat(item)
                        let el = {
                            key: item,
                            rate: rates[item],
                            value: num.toFixed(2)>0?num.toFixed(2):0.01
                        }
                        this.hb_rates.push(el)
                    }
                }
            })
        },
        closeModal(){
            this.payModalStatus = false
        },
        goBack(){
            history.go(-1);
        },
        close(){
            let vm = this;
            vm.showTips = false;
            vm.$router.replace({name:"orderList"});
        },
        closeDialog(){
            this.showDialog = false;
        },
        selectType(type){
            this.payType = type;
            sessionStorage.payType = type;

            let vm = this
            if(type!='huabei'){
                setTimeout(function(){
                    vm.itemIndex = 1
                },1000)
            }
        },
        getOrderDetail(){
            let access_token = localStorage.access_token;
            let orderno = this.$route.query.orderno;
            if(!orderno){
                this.$router.replace({name:"orderList"});
                return
            }
            let info = {
                access_token:access_token,
                orderno:orderno
            }
            let vm = this;
            Indicator.open('加载中');
            this.$store.dispatch("getOdinfo",info).then((res)=>{
                Indicator.close();

                var data = res.data;
                if(data.code == 0){
                    vm.order = data.res.order;
                    vm.service_orders = vm.order.service.service_orders
                    vm.getSystemConfig()
                    if(vm.sorder_no){
                        vm.total = this.$route.query.price;
                        vm.g_description = this.$route.query.g_description;
                        vm.gm_name = this.$route.query.gm_name;
                        sessionStorage.orderno = this.orderno;
                    }else {
                        vm.total = vm.order.total
                        vm.g_description = vm.order.detail[0].g_description
                        vm.gm_name = vm.order.detail[0].gm_name
                    }
                }else if(data.code == 1200){
                     new Promise(vm.refreshToken).then(function(token){
                         info.access_token = token;

                         vm.$store.dispatch("getOdinfo",info).then((res)=>{
                             var data = res.data;
                            if(data.code == 0){
                                vm.order = data.res.order;
                            }else{
                                vm.$router.push({name:"login"})
                            }
                         })
                     })

                }else if(data.code == 1201){
                    vm.$router.push({name:"login"})
                }


                let temp = this.order.detail[0].gm_name.split('（');
                this.packageName = temp[0]
                sessionStorage.packageName = this.packageName

                setTimeout(function(){
                    Indicator.close();
                },300)

            })
        },
        async pay(){
            let vm = this;
            let orderno = vm.$route.query.orderno;
            var url = window.config.payResult+'orderno=';
            let access_token =  localStorage.access_token;
            
            let info = {
                orderno:orderno,
                type:vm.payType,
                return_url:url,
                access_token:access_token
            }
            if(vm.payType=='huabei'){
                info['type'] = 'alipay'
                info['hb_fq_num'] = vm.hb_num
            }
            if(!vm.validToken()){
                return
            }                    
            
            vm.postPay(info, vm.pay)
        },
      
        async pay_svr(){

            let vm = this;
            let sorder_no = this.sorder_no;
            var url = window.config.payResult+'sorder_no=';
            let access_token =  localStorage.access_token;
            let info = {
                sorder_no:sorder_no,
                type:vm.payType,
                return_url:url,
                access_token:access_token
            }
            if(vm.payType=='huabei'){
                info['type'] = 'alipay'
                info['hb_fq_num'] = vm.hb_num
            }
            vm.postPay(info,vm.pay_svr);
        },
        async postPay( info, cb ){
            let vm = this;
            const res = await vm.$store.dispatch( 'wapPay' ,info);
            var data = res.data;
            var paydata = data.res.paydata;
            if(data.code == 0){
                vm.handlePayResult(paydata);
            }
            if(data.code == 1200){
                await new Promise(vm.refreshToken);
                cb();
            }
            if(data.code == 1201){
                vm.$router.push({name:"login"})
            }
            if(data.code == 2002){
                vm.showTips = true;
                setTimeout(function(){
                    vm.showTips = false;
                    vm.$router.replace({name:"orderList"});
                },1000)
                clearTimeout(vm.clock);
                vm.showDialog = false;
            }
        },
        handlePayResult(paydata){
            var vm = this;
            let pay_url;
            if(vm.payType == "wxpay-h5"){
                pay_url = paydata.mweb_url;
            }else{
                pay_url = paydata.pay_url;
            }
            window.location.href = pay_url;
        },
        browserIsOk(){
            const _isWeiXin = this.isWeiXin();//微信浏览器
            const _isAlipay = this.isAlipay();//支付宝浏览器
            const payType = this.payType;
            const ok = !_isWeiXin && (!_isAlipay || (_isAlipay && payType != 'wxpay-h5')) ;
            if(!ok){
                this.$store.commit('changeNotice')
            }
            return ok
        },
       
       
        gopay(){
            let vm = this;

            let service_fee = 0
            let discount = 0
            let huabei = '-1'

            if(this.payType == 'huabei'){
                huabei = this.hb_num
                
            }
            localStorage.huabei_num = huabei

            if(this.sorder_no){
                let service_order = _.find(vm.service_orders,function(o){
                    return o.status == '2'
                })
                service_fee = service_order.total
                if(service_order.discount){
                    discount = service_order.discount
                }
            }
            
            this.sa_m_click_pay(
                this.order.orderno, 
                this.order.total_price, 
                this.order.adress.kxuid, 
                this.packageName, 
                this.order.detail[0].g_description,
                this.order.detail[0].price,
                service_fee,
                discount,
                huabei
            );
            
            const ok = this.browserIsOk()
            if(ok){
                
                if(vm.payType=='scanpay'){
                    vm.action = 'selectScanType'
                    for(let item of this.qr_codes){
                        this.getPayInfo(item.type).then((code)=>{
                            item.code_url = code
                        })
                    }
                    vm.clock = setTimeout(function(){
                        vm.payModalStatus = true;
                    },500);
                }else if(this.sorder_no){
                    this.pay_svr()
                }else{
                    this.pay()
                }
            }
        },
      
        payComplete(){//支付完成
            if(this.sorder_no){
                this.$router.push({name:"payresult",query:{sorder_no:this.sorder_no,orderno:this.orderno}})
            }else{
                this.$router.push({name:"payresult",query:{orderno:this.orderno}})
            }
        },

        async getPayInfo(type){
            let access_token = localStorage.access_token
            let info = {
                type: type,
                access_token: access_token,
                redirect: 1
            }

            let res1
            if(!this.sorder_no){
                info['orderno'] = this.orderno
                res1 = await this.$store.dispatch('getPayInfo',info)
            }else {
                info['sorder_no'] = this.sorder_no
                res1 = await this.$store.dispatch('getSvrInfo',info)
            }
            
            let result = res1.data
            if(result.code == 0){
                let data = { 
                    access_token: access_token,
                    qr_code: encodeURIComponent(result.res.code_url)
                 }
                let res2 = await this.$store.dispatch('createQrCode',data)
                let dom = window.URL.createObjectURL(res2.data)
                return dom
            }
        }

    },
    created(){
        this.goodsCategory = sessionStorage.goodsCategory;
        this.orderno = this.$route.query.orderno;
        this.sorder_no = this.$route.query.sorder_no;
        this._isWeiXin = this.isWeiXin();
        this._isAlipay = this.isAlipay();
        
        this.getOrderDetail();
    },
    mounted(){
        
    },
    components:{
        Popup,
        Radio,
        toastPay,
        OpenInsafari,
        swipe
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Pay.vue